export default "__VITE_ASSET__BAxxoBmT__"